import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const CalendarIcon = _ref => {
  let {
      size = "16",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, __jsx("g", {
    "clip-path": "url(#clip0_25551_78720)"
  }, __jsx("path", {
    d: "M3.5 0C3.77614 0 4 0.223858 4 0.5V1H12V0.5C12 0.223858 12.2239 0 12.5 0C12.7761 0 13 0.223858 13 0.5V1H14C15.1046 1 16 1.89543 16 3V4V5V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V5H16V4H0V3C0 1.89543 0.895431 1 2 1H3V0.5C3 0.223858 3.22386 0 3.5 0Z",
    fill: "#757474"
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "clip0_25551_78720"
  }, __jsx("rect", {
    width: "16",
    height: "16",
    fill: "white"
  }))));
};
export default CalendarIcon;